/**
 * Control transparent header based on scrolling.
 */
(() => {
    /**
     * How many pixels from the top the user needs to scroll before the header becomes opaque.
     */
    const threshold = 40;

    function onScroll(e) {
        document.documentElement.classList.toggle(
            '-is-scrolled-to-top',
            window.scrollY < threshold
        );
    }

    document.addEventListener('scroll', onScroll);
    onScroll();
})();
